import React from "react";
import Video from "../../video/Video"
import Figure from "../figure"
import Artifact from "../artifact"

const House = () => (
  <Artifact>
    <Figure 
      caption="Candé&rsquo;s family home in Guinea-Bissau"
      captionAlign="left"
      captionSize="small"
    >
      <Video
        src="https://cdn.theoutlawocean.com/al-mabani/clips__guinea-bissau.mp4"
        muted="muted"
        autoplay="autoplay"
        loop="loop"
      />
    </Figure>
  </Artifact>
);

export default House;
export { House }